function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */


import SmartCollection from './smart_collection';
import MCPOption from './multiple_choice_poll_option';
import _ from 'underscore'; // @namespace Model

var MCPOptions = /*#__PURE__*/function (_SmartCollection) {
  _inheritsLoose(MCPOptions, _SmartCollection);

  function MCPOptions() {
    return _SmartCollection.apply(this, arguments) || this;
  }

  var _proto = MCPOptions.prototype;

  _proto.highestResult = function highestResult() {
    return _.max(_(this.pluck('results_count')).map(function (num) {
      return parseFloat(num);
    }));
  };

  _proto.lowestResult = function lowestResult() {
    return _.min(_(this.pluck('results_count')).map(function (num) {
      return parseFloat(num);
    }));
  };

  _proto.hasImage = function hasImage() {
    return this.any(function (option) {
      return option.isImage();
    });
  };

  _proto.hasAlphaNumericKeyword = function hasAlphaNumericKeyword() {
    return this.any(function (option) {
      return option.isKeywordAlphaNumeric();
    });
  };

  _proto.hasLatex = function hasLatex() {
    return this.any(function (option) {
      return option.isLatex();
    });
  };

  _proto.hasCorrect = function hasCorrect() {
    return this.any(function (option) {
      return option.isCorrect();
    });
  };

  _proto.resetKeywords = function resetKeywords(mcpOptions) {
    var _this = this;

    _.each(mcpOptions, function (option) {
      var existingOption = _this.get(option.id); // reset the initial keyword in the keyword validator mixin


      return existingOption != null ? existingOption.resetKeyword(_.pick(option, 'keyword', 'auto_keyword')) : undefined;
    });
  };

  _proto.ordinalRank = function ordinalRank(mcpOption) {
    if ((this.poll != null ? this.poll.type() : undefined) !== 'ranking_poll') {
      return;
    }

    var resultCounts = this.map(function (model) {
      return model.get('results_count');
    });

    var sorted = _(resultCounts).sortBy(function (resultCount) {
      return parseFloat(resultCount);
    });

    return _(sorted).indexOf(mcpOption.get('results_count')) + 1;
  };

  _createClass(MCPOptions, [{
    key: "model",
    get: function get() {
      return MCPOption;
    }
  }]);

  return MCPOptions;
}(SmartCollection);

export { MCPOptions as default };